import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.4/js/sparta-events-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.3/js/sparta-global-functions-utility";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/3.0.5/js/sparta-mediaquery-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import spartaStyleUtility from "utilities/global/sparta-style-utility/4.5.0/js/sparta-style-utility";
import _ from "utilities/vendor/lodash/4.17.21/js/lodash.custom.min";
import spartaBrowserSupportUtility from "utilities/global/sparta-browser-support-utility/4.4.0/js/sparta-browser-support-utility";
import spartaPolyfillUtility from "utilities/global/sparta-polyfill-utility/1.5.1/js/sparta-polyfill-utility";
import spartaRequireUtility from "utilities/global/sparta-require-utility/2.3.5/js/sparta-require-utility";
import spartaTemplatesUtility from "utilities/global/sparta-templates-utility/2.0.0/js/sparta-templates-utility";
import spartaTransportUtility from "utilities/global/sparta-transport-utility/4.1.0/js/sparta-transport-utility";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/6.4.2/js/sparta-ui-layers-utility";







const EVENTS = {
  SPARTA_GLOBAL_READY: 'SPARTA_GLOBAL_READY.spartaBootstrapUtility',
  SPARTA_SECONDARY_READY: 'SPARTA_SECONDARY_READY.spartaBootstrapUtility',
  SPARTA_WINDOW_SCROLL: 'SPARTA_WINDOW_SCROLL.spartaBootstrapUtility',
};

const setupVue = (context) => {
  if (!context.vue) {
    return new Promise((resolve) => {
      spartaRequireUtility.getResourceByName('/vue/').then((data) => {
        context.vue = data;
        resolve();
      });
    });
  }
  return Promise.resolve();
};

const setupVuex = context => new Promise((resolve) => {
  if (!context.vuex) {
    let Vuex;
    spartaRequireUtility.getResourceByName('/vuex/')
      .then((data) => {
        context.vuex = data;
        Vuex = context.vuex;
        return setupVue(context);
      })
      .then(() => {
        if (context.vue && Vuex && !context._vuexStore) {
          context.vue.use(Vuex);
          context._vuexStore = new Vuex.Store();
          resolve();
        }
      })
      .catch(error => console.log(error));
  } else {
    resolve();
  }
});






const isVueTemplate = tmpl => tmpl && tmpl.constructor === String;







const vueComponentDefinition = (module, definition) => new Promise((resolve) => {
  const modName = module.settings.moduleInfo.name;
  spartaRequireUtility.getResourcesByWords(modName, 'templates').then((templateObj) => {
    const template = templateObj[0] && templateObj[0].default;
    const modComponentDefinition = definition.bind(module)();
    if (isVueTemplate(template)) {
      const vueTemplateStr = template.replace(/\\n/g, ' ');
      return resolve({ ...modComponentDefinition, template: vueTemplateStr });
    }
    return resolve({ ...modComponentDefinition });
  });
}).catch(error => console.log(error));

function publishGlobalReadyEvents(loop, events) {
  if (loop.total === 1) {
    spartaEventsUtility.pub(events.SPARTA_GLOBAL_READY);
  }
  if (loop.total === 2) {
    if (loop.completed === 0) {
      spartaEventsUtility.pub(events.SPARTA_GLOBAL_READY);
    } else if (loop.completed > 0) {
      spartaEventsUtility.pub(events.SPARTA_SECONDARY_READY);
    }
  }
}

class SpartaBootstrapUtility {
  constructor() {
    this.modules = [];
    this.initedModules = [];
    this.moduleInstances = [];
    this.appContainer = null;
    this.browser = spartaStoreUtility.getData('browser');
    this.loop = { total: 1, completed: 0 };
  }

  get EVENTS() {
    return EVENTS;
  }

  get vuexStore() {
    return this._vuexStore;
  }

  set vuexStore(store) {
    this._vuexStore = store;
  }





  init(requireArgs = [], componentInfo) {
    this.setApplicationData(componentInfo);
    this.checkForLangOverride();
    this.setupSpaParams(componentInfo);
    this.loadOptionsFromContainer();
    this.setupGlobalEvents();
    this.clearResourceLoad();
    this.createAndInitModules(requireArgs).then(() => {
      if (!spartaStoreUtility.getData('spaParams').isSPA || spartaStoreUtility.getData('spaParams').isSPA === 'false') {
        publishGlobalReadyEvents(this.loop, this.EVENTS);
      } else {
        spartaRequireUtility.getRequire()(['vendor/vuejs/vue', 'vendor/vuejs/vue-router'], (vue, vuerouter) => {
          this.Vue = vue;
          this.VueRouter = vuerouter;
          this.Vue.use(this.VueRouter);
          this.initializeRouter().then(() => publishGlobalReadyEvents(this.loop, this.EVENTS));
        });
      }
    });
  }

  setLoop(loopObj) {
    this.loop = loopObj;
  }

  clearResourceLoad() {
    if (spartaRequireUtility.getRequire().dependenciesMap) {
      spartaRequireUtility.getRequire().onResourceLoad = undefined;
    }
  }

  setupSpaParams(componentInfo) {
    let spaParams;
    if (componentInfo && componentInfo.name) {
      if (window.sparta.videoParams) {
        spaParams = window.sparta.videoParams[componentInfo.name][componentInfo.version];
      } else {
        spaParams = window
          .spaWidgetParams[componentInfo.name][componentInfo.version][componentInfo.id];
      }
    } else {
      ({ spaParams } = window);
    }


    spaParams.siteParams = spaParams.siteParams || spaParams.params;
    const lang = (componentInfo && componentInfo.name) ? spartaStoreUtility.getData('lang').split('-')[0] : window.sparta.language;
    const language = lang || 'en';
    spaParams.language = language;
    spartaStoreUtility.addData('spaParams', spaParams);


    const bankHolidays = spaParams.global[spaParams.language]
      ? spaParams.global[spaParams.language].bankHolidays
      : null;
    if (bankHolidays) {
      spartaStoreUtility.addData('bankHolidays', bankHolidays);
    }

    spartaEventsUtility.pub(spartaEventsUtility.EVENTS.SPA_PARAMS_LOADED, spaParams);
  }

  setApplicationData(componentInfo) {
    let appContainer;
    let mediaQueryContainer;

    const isVideo = !!(
      componentInfo
      && componentInfo.name
      && componentInfo.version
      && !componentInfo.id
    );
    const isWidget = !!(
      componentInfo
      && componentInfo.name
      && componentInfo.version
      && componentInfo.id
    );
    spartaStoreUtility.addData('isWidget', isWidget);

    if (isWidget) {
      const widgetContainers = document.querySelectorAll(`[data-sparta-container="${componentInfo.name}"][data-version="${componentInfo.version}"][data-id="${componentInfo.id}"]`);

      mediaQueryContainer = document.querySelector(`[data-sparta-wrapper="${componentInfo.name}-${componentInfo.version}-${componentInfo.id}"]`);

      if (widgetContainers) {

        if (widgetContainers.length === 1) {
          [appContainer] = widgetContainers;
        } else if (widgetContainers.length > 1) {
          throw new Error('the ID of a widget container must be unique');
        }
      }

      spartaStoreUtility.addData('applicationContext', componentInfo);
    } else if (isVideo) {
      const videoContainers = document.querySelectorAll(`[data-sparta-container="${componentInfo.name}"][data-version="${componentInfo.version}"]`);

      mediaQueryContainer = document.querySelector(`[data-sparta-wrapper="${componentInfo.name}-${componentInfo.version}"]`);

      if (videoContainers) {

        if (videoContainers.length === 1) {
          [appContainer] = videoContainers;
        } else if (videoContainers.length > 1) {
          throw new Error('the ID of a video container must be unique');
        }
      }

      spartaStoreUtility.addData('applicationContext', componentInfo);
    } else if (window.sparta.mlGlobalData) {


      spartaStoreUtility.addData('csrfToken', window.sparta.mlGlobalData.csrfToken);
    }

    spartaEventsUtility.pub(spartaEventsUtility.EVENTS.APP_CONTEXT_LOADED, spartaStoreUtility.getData('applicationContext'));

    if (!appContainer) {
      let topContainer = document.querySelectorAll('[data-sparta-container]');
      mediaQueryContainer = document.querySelector('[data-sparta-wrapper]');

      if (!topContainer) {
        console.error('unable to find a sparta component - ensure data-sparta-container is set');
        return;
      }

      topContainer = [...topContainer].filter(el => !el.classList.contains('sparta-widget-container'));
      if (topContainer.length !== 1) {
        console.error('too many containers on page, must use widget configuration or loader');
        return;
      }

      [appContainer] = topContainer;
    }

    this.appContainer = appContainer;
    spartaMediaQueryUtility.init(mediaQueryContainer || appContainer);

    this.appContainer = this.appContainer.length
      ? [].slice.call(this.appContainer)
      : this.appContainer;

    spartaStoreUtility.addData('applicationContainer', this.appContainer);
    spartaEventsUtility.pub(spartaEventsUtility.EVENTS.APP_CONTAINER_LOADED, appContainer);
  }





  loadOptionsFromContainer() {
    const appContainer = spartaStoreUtility.getData('applicationContainer');
    const containers = [].slice.call(Array.isArray(appContainer) ? appContainer : [appContainer]);
    const optionsObj = JSON.parse(containers[containers.length - 1].getAttribute('data-sparta-options')) || {};
    spartaStoreUtility.addData('applicationOptions', optionsObj);
  }




  checkForLangOverride() {
    const containers = spartaStoreUtility.getData('applicationContainer');
    const appContainer = [].slice.call(Array.isArray(containers) ? containers : [containers]);
    const langOverride = (
      appContainer && appContainer[appContainer.length - 1].getAttribute('data-sparta-lang')
    ) || null;

    if (langOverride) {
      spartaStoreUtility.addData('lang', langOverride.toLowerCase());
    }
  }

  setupStores() {
    return new Promise((resolve) => {
      this.registerStores()
        .then(() => this.registerSharedComponents())
        .then(() => resolve());
    });
  }





  createModuleInstances(requireArgs) {
    const containers = spartaStoreUtility.getData('applicationContainer');
    const applicationContainer = Array.isArray(containers)
      ? containers[containers.length - 1]
      : containers;
    const boaModules = this._getUninitializedModules(
      [...applicationContainer.querySelectorAll('[data-component="module"]')],
    );
    const deps = [...requireArgs];
    const depModuleMap = {};

    deps.forEach((dep) => {
      if (!dep || typeof dep.default !== 'function') {
        return;
      }
      const name = dep.default.toString().match(/^function\s*([^\s(]+)/)[1];
      depModuleMap[name] = dep;
    });

    boaModules.forEach((moduleDom) => {
      const className = moduleDom.getAttribute('data-init');
      if (className) {
        const module = depModuleMap[className];


        const options = JSON.parse(moduleDom.getAttribute('data-options')) || {};


        options.target = moduleDom;


        if (!this.moduleInstances[className]) {
          this.moduleInstances[className] = [];
        }
        if (typeof module !== 'undefined') {

          this.moduleInstances[className].push(new module.default(options));
        }



        moduleDom.classList.remove('spa-module-init');
      }
    });

    spartaStoreUtility.addData('moduleInstances', this.moduleInstances);
  }

  registerStores() {
    const paths = spartaRequireUtility.filterResourcesByWords('stores', 'index');
    return new Promise((resolve) => {
      spartaRequireUtility.getResourcesByPaths(...paths)
        .then((stores) => {
          if (stores.length) {
            const storesWithPaths = paths.map((path, i) => ({ ...stores[i], path }));
            const storeObjs = this.getStores(storesWithPaths);
            storeObjs.forEach((store) => {
              const [namespace, module] = store;
              if (this.vuexStore.hasModule(namespace)) {
                return;
              }
              this.vuexStore.registerModule(namespace, module);
            });
          }
          resolve();
        })
        .catch(error => console.log(error));
    });
  }

  registerSharedComponents() {
    return new Promise((resolve) => {
      spartaRequireUtility.getResourcesByWords('utilities/shared-components/')
        .then((modules) => {
          if (!modules.length) {
            return resolve();
          }
          modules.forEach((module) => {
            if (!module._spartaComponentConfig) {
              return;
            }
            const exportName = this.getExportName(module);
            if (!this.vue.options.components[exportName]) {
              this.vue.component(exportName, module.default);
            }
          });
          return resolve();
        })
        .catch(error => console.log(error));
    });
  }

  getExportName(module) {
    const exportName = module._spartaComponentConfig.export;
    if (typeof exportName === 'string') {
      return exportName;
    }
    return exportName[0];
  }






  getStores(stores) {
    return stores.map((store) => {
      const { path } = store;
      const storeNamespaces = path.split('utilities/stores/')[1].split('/js/')[0];
      const exportName = this.getExportName(store);
      const namespace = exportName || storeNamespaces.slice(0, storeNamespaces.length - 1);
      return [namespace, {
        ...store.default,
        namespaced: true,
      }];
    });
  }





  verifyUniqueModuleIds(module) {
    if (!module.settings.target || !module.settings.target.id) {
      return;
    }

    const moduleContainers = document.querySelectorAll(`[id="${module.settings.target.id}"]`);

    if (moduleContainers && moduleContainers.length > 1) {
      let imSettings;
      const mSettings = module.settings;
      this.initedModules.reverse().every((im) => {
        imSettings = im.module.settings;
        if (
          imSettings.moduleInfo
          && imSettings.moduleInfo.name === mSettings.moduleInfo.name
          && imSettings.target.id.startsWith(mSettings.target.id)
        ) {

          mSettings.target.totalInstances = (imSettings.target.totalInstances || 0) + 1;


          delete imSettings.target.totalInstances;


          mSettings.target.id += mSettings.target.totalInstances;
          return false;
        }
        return true;
      });
    }
  }

  runInit(module) {
    const mainModule = module.module;
    mainModule.router = this.routerInstance;
    if (mainModule[module.init]) mainModule[module.init](module.args);
    module.state = 'initialized';
    mainModule.vuexStore = this.vuexStore;
    this.initedModules.push(module);
  }

  wrapInitModules() {
    return new Promise((resolve) => {
      const pageContainsStores = spartaRequireUtility.filterResourcesByWords('/stores/');
      if (pageContainsStores.length) {
        setupVuex(this)
          .then(() => this.setupStores())
          .then(() => Promise.all(this.initModules()))
          .then(() => resolve());
      } else {
        setupVue(this)
          .then(() => this.registerSharedComponents())
          .then(() => Promise.all(this.initModules()))
          .then(() => resolve());
      }
    }).catch(error => console.log(error));
  }




  initModules() {
    const spaParams = spartaStoreUtility.getData('spaParams');
    return this.modules.map(async module => new Promise((resolve) => {
      if (module.state === 'ready') {
        const mainModule = module.module;
        const { componentDefinition } = mainModule;
        this.verifyUniqueModuleIds(mainModule);
        mainModule.vuex = this.vuex;
        if (!componentDefinition) {


          return resolve(this.runInit(module));
        }
        setupVue(mainModule)
          .then(() => {
            const vueModulePlaceholder = document.createElement('div');
            mainModule.settings.target.appendChild(vueModulePlaceholder);
            mainModule.vueComponent = {
              el: vueModulePlaceholder,
              store: this.vuexStore,
            };
            if (spaParams.isSPA) {
              this.vuexStore.$router = this.routerInstance;
              mainModule.vueComponent.router = this.routerInstance;
            }
            return vueComponentDefinition(mainModule, componentDefinition);
          })
          .then((vueDef) => {

            mainModule.vueComponent = new mainModule.vue({
              ...mainModule.vueComponent,
              ...vueDef,
            });
            return resolve(this.runInit(module));
          });
      }
    }));
  }







  register(module, args = {}, init = 'init') {
    this.modules.push({
      state: 'ready',
      module,
      init,
      args,
    });
  }




  setupGlobalEvents() {

    window.addEventListener('scroll', _.throttle((e) => {
      spartaEventsUtility.pub(this.EVENTS.SPARTA_WINDOW_SCROLL, [window.pageYOffset, e]);
    }, 20));
  }




  onloadHelpers() {
    const containers = spartaStoreUtility.getData('applicationContainer');
    const applicationContainer = Array.isArray(containers)
      ? containers[containers.length - 1]
      : containers;


    const spaFnElems = this._getUninitializedModules(
      [...applicationContainer.querySelectorAll('.spa-fn')],
    );
    if (!spaFnElems.length) {
      return;
    }

    const onloadHelperRegister = ['.spa-boa-window', '.spa-mobile-tel'];

    onloadHelperRegister.forEach((helperClass) => {
      if (helperClass === '.spa-mobile-tel' && !this.browser.mobile) {
        return;
      }
      const elsToProcess = this._getUninitializedModules(applicationContainer.querySelectorAll(`.spa-fn${helperClass}`));

      if (elsToProcess.length) {
        switch (helperClass) {
          case '.spa-boa-window':
            spartaUILayersUtility.addPopupWindowHelper(elsToProcess);
            break;
          case '.spa-mobile-tel':
            spartaGlobalFunctions.mobilePhoneFormatHelper(elsToProcess);
            break;
          default:
            break;
        }
      }
    }, this);
  }




  _getUninitializedModules(modules) {
    return _.filter(modules, module => !_.find(
      this.initedModules,
      initedModule => (initedModule.module.settings.target === module),
    ));
  }

  loadOnDemandHelpers(helpers) {
    return Promise.all(helpers.map(helper => spartaRequireUtility.getRequirePromise([helper])))
      .then(
        (helperExports) => {
          helperExports.forEach(helperExport => helperExport.register(Handlebars));
        },
      );
  }

  initializeRouter() {
    const spaParams = spartaStoreUtility.getData('spaParams');
    const routerModule = this.initedModules[0].module;
    const spaAssetsHref = document.querySelector('[href*=spa-assets]').href;
    const spaMapUrl = `/${spaAssetsHref.substring(0, spaAssetsHref.indexOf('/spa-assets/') + 12).replace(/^[a-zA-Z]{3,5}:\/{2}[a-zA-Z0-9_.:-]+\//, '')}spa-map.json`;

    return new Promise((resolve, reject) => {
      spartaTransportUtility.subscribe({
        cache: true,
        dataType: 'json',
        success: (data) => {
          resolve(data);
        },
        error: () => {


          reject();
        },
        url: spaMapUrl,
      });
    }).then((spaMap) => {
      this.spaMap = spaMap;
      if (!routerModule.baseHelpersPromise) {
        routerModule.baseHelpersPromise = (spaMap && spaMap.baseHelpers)
          ? this.loadOnDemandHelpers(spaMap.baseHelpers)
          : undefined;
      }
      spaParams.onDemandModules.baseHelpers = spaMap.baseHelpers;

      const altLanguageRoutes = this.getAltLanguageRoutes(spaMap.routes);
      spaMap.routes = [...spaMap.routes, ...altLanguageRoutes];

      const routes = _.map(spaMap.routes, (route, i) => ({
        name: route.name,
        path: route.path,
        meta: {
          routeIndex: i,
        },
        component: async (resolve, reject) => {
          try {
            return resolve({
              render: (h) => h('div', {
                style: {
                  display: 'none',
                },
                domProps: {
                  innerHTML: Math.random(),
                },
              }),
            });
          } catch (error) {
            return reject(error);
          }
        },
      }));

      this.routerInstance = new this.VueRouter({
        routes,
        mode: 'history',
      });
      this.initedModules.forEach((module) => {
        module.module.router = this.routerInstance;
      });

      const vueRoutePlaceholder = document.createElement('div');
      vueRoutePlaceholder.id = 'routerVueInstanceContainer';

      document.body.appendChild(vueRoutePlaceholder);


      const self = this;

      const app = new this.Vue({
        el: vueRoutePlaceholder,
        router: this.routerInstance,
        template: '<div><router-view/></div>',
        watch: {
          $route(to, from) {
            try {
              if (from && to && from !== to && self.spaMap.routes[to.meta.routeIndex]) {
                spartaRequireUtility.resetHandlebarHelperFlag();
                spaParams.pageParams = self.spaMap.routes[to.meta.routeIndex].pageDetails
                  .pageParams;
                self.clearRouteModules(self.spaMap.routes[from.meta.routeIndex]);
                self.loadRouteModules(self.spaMap.routes[to.meta.routeIndex]);
              }
            } catch (error) {
              console.warn(`Unable to find page for path ${to.path}.`);
            }
          },
        },
      });
    });
  }

  getAltLanguageRoutes(routes) {
    const altLangRoutes = [];
    _.each(routes, (route) => {
      route.language = 'en';

      let altLanguages;
      if (spaParams.pageParams.languages) {
        altLanguages = [...spaParams.pageParams.languages.languages].filter((lang) => lang !== 'en');
      } else if (route.pageDetails.pageParams.languages) {
        altLanguages = [...route.pageDetails.pageParams.languages.languages].filter((lang) => lang !== 'en');
      } else {
        console.error('Unable to find `languages` parameter for this page. Routing to languages other than English will not be supported.');
      }
      if (altLanguages) {

        _.each(altLanguages, (language) => {
          altLangRoutes.push({
            path: `${route.path.replace(/\/$/, '')}/${language}`,
            name: route.name,
            pageDetails: route.pageDetails,
            modules: route.modules,
            language,
          });
        });
      }
    });
    return altLangRoutes;
  }

  async loadRouteModules(route) {
    window.sparta.language = route.language;
    spaParams.language = route.language;
    spartaStoreUtility.addData('spaParams', spaParams);
    spartaEventsUtility.pub(spartaEventsUtility.EVENTS.SPA_PARAMS_LOADED, spaParams);
    const refModule = this.initedModules[0].module;
    this.routeModulesContainer = this.routeModulesContainer || document.querySelector(
      '#dynamic-row-body > .row > .column, #dynamic-row-body > .row > .columns',
    );

    const onDemandModules = { modules: {} };
    _.each(route.modules, (mod) => {
      onDemandModules.modules[mod.ref] = mod;
    });

    const modules = await refModule.mountAll(
      _.map(route.modules, (mod) => ({
        ...mod,
        module: mod.ref,
      })),
    );

    const mainJS = modules.map((m) => m.mainJS);

    const moduleHtml = modules.map((m) => m.html);

    this.routeModulesContainer.innerHTML = moduleHtml.join('');
    this.createAndInitModules(mainJS);
  }

  clearRouteModules(route) {
    const initedModules = [];
    let clearModule = true;
    this.initedModules.forEach((m) => {
      clearModule = false;
      if (route) {
        route.modules.forEach((module) => {
          if (module.name === m.module.settings.moduleInfo.name) {
            clearModule = true;
          }
        });
      }
      if (!clearModule) {
        initedModules.push(m);
      } else {

        if (m.module.vueComponent) {
          m.module.vueComponent.$destroy();
        }

        if (m.module.destroy) {
          m.module.destroy();
        }
      }
    });

    this.initedModules = initedModules;

    while (this.routeModulesContainer && this.routeModulesContainer.firstChild) {
      this.routeModulesContainer.removeChild(this.routeModulesContainer.firstChild);
    }
  }





  createAndInitModules(requireArgs) {
    return new Promise((resolve) => {

      this.createModuleInstances(requireArgs);

      this.onloadHelpers();
      this.wrapInitModules().then(() => {
        resolve();
      });
    }).catch(error => console.error(error));
  }
}

export default new SpartaBootstrapUtility();
